import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';

export const gridSpan = responsive({
  0: 'span 1',
  3: 'span 2',
  4: 'span 4',
});

const groups: ThemeUICSSObject = {
  upsertion: {
    fieldset: {
      display: 'grid',
      gridTemplateColumns: responsive({
        0: '1fr',
        2: 'repeat(2, 1fr)',
        4: 'repeat(4, 1fr)',
      }),
      gap: spacing(4),
      p: spacing(7),
      border: 'none',
      ...getColorsByPath('tab'),

      '.checkbox': {
        display: 'flex',
        gridColumn: gridSpan,
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'start',
        gap: spacing(4),

        span: {
          m: spacing(0),
          fontWeight: 'normal',
        },
      },

      '.imageSelector': {
        gridColumn: gridSpan,
        alignItems: 'start',
        '&>div': { gap: spacing(0) },
      },

      '.environmentsSelector': {
        gridColumn: gridSpan,
        display: 'block',
        span: {
          fontWeight: 'bold',
        },

        '.environments': {
          display: 'flex',
          flexWrap: 'wrap',
          listStyle: 'none',
          gap: spacing(4),
          padding: 0,
          marginTop: 0,
          mb: spacing(4),
        },
      },

      '.textarea': {
        gridColumn: gridSpan,

        textarea: {
          height: '15vh',
          mt: spacing(1),
        },
      },

      '& label': {
        display: 'block',
      },
    },
  },
};

export default groups;
